module.exports = __webpack_public_path__ + "static/media/IMG_0007.84137b78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery-db/IMG_0007.jpg
// module id = 458
// module chunks = 0